import { updateOrgIdAndCompanyIdService } from '../../../services/boteria/updateOrgIdAndCompany';

export function updateOrgIdAndCompanyIdAction (company, org, claimIsRoot, token) {
	return {
		type: 'UPDATE_ORG_ID_AND_COMPANY_ID',
		payload: updateOrgIdAndCompanyIdService(company, org, claimIsRoot, token)
	}
}